import { useUnit } from 'effector-react'
import { Button } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import * as chat from '@/entities/chat'
import { useI18n } from '@/shared/lib/i18n'

import { navbarChatButton } from './recipe'

export function ChatButton() {
    const { i18n } = useI18n()

    const isChatOpen = useUnit(chat.$isChatOpen)
    const unreadReplyCounter = useUnit(chat.$chatUnreadReplyCounter)
    const showUnreadBadge = unreadReplyCounter > 0 && !isChatOpen

    const classes = navbarChatButton({ isChatOpen })

    const handleChatToggle = useUnit(chat.chatToggled)

    return (
        <li className={css({ paddingLeft: '[10px]' })}>
            <Button onClick={() => handleChatToggle({ open: !isChatOpen })} className={classes.root}>
                <i className="fa-solid fa-messages" />
                {isChatOpen ? i18n.CHAT_TITLE_CLOSE : i18n.CHAT_TITLE}
                {showUnreadBadge && <span className={classes.unreadBadge} />}
            </Button>
        </li>
    )
}
